import React from "react";
import { Card, CardContent, Typography, Box, alpha } from "@mui/material";
import {
  Bar,
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { useTheme } from "@emotion/react";
import useStyles from "./styles";
const StarRatingChart = ({
  mainLineColor = null,
  gridOptions = {},
  data = [],
  title = "Distribuição de Avaliações",
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);

  const colors = [
    theme.palette.colors.red.medium,
    theme.palette.colors.orange.medium,
    theme.palette.colors.purple.medium,
    theme.palette.colors.blue.medium,
    theme.palette.colors.green.medium,
  ];
  const MAIN_LINE_COLOR =
    mainLineColor || theme.palette.cardGraphic.graphLineColor.blue;
  const chartData = data.map((item, index) => ({
    ...item,
    color: colors[index],
  }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <Box
          sx={{
            ...styles.containerCustomTooltip,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {`${label} ${label === 1 ? "estrela" : "estrelas"}`}
          </Typography>
          <Typography variant="body2" color="primary">
            {`${payload[0].value} respostas`}
          </Typography>
        </Box>
      );
    }
    return null;
  };

  const mergedGridOptions = {
    stroke: MAIN_LINE_COLOR,
    strokeOpacity: 0.5,
    vertical: false,
    strokeDasharray: "3",
    ...gridOptions,
  };

  return (
    <Box sx={{ height: "100%" }} key={"graph"}>
      <CardContent sx={{ height: "100%" }}>
        <Typography sx={styles.title}>{title}</Typography>

        <Box sx={{ height: 160 }}>
          <ResponsiveContainer width="100%" height={"100%"}>
            <BarChart
              data={chartData}
              height={"100%"}
              margin={{
                top: 20,
                right: 30,
                left: -10,
                bottom: 5,
              }}
            >
              <CartesianGrid {...mergedGridOptions} />
              <XAxis
                dataKey="star"
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12, fill: theme.palette.text.secondary }}
                formatter={(value) => `${value}★`}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12, fill: theme.palette.text.secondary }}
              />
              <Tooltip
                content={CustomTooltip}
                cursor={{
                  fill:
                    theme.palette.mode == "dark"
                      ? alpha(theme.palette.colors.black.medium, 0.4)
                      : alpha(theme.palette.colors.black.light, 0.4),
                }}
              />
              <Bar
                dataKey="count"
                isAnimationActive={false}
                radius={[4, 4, 0, 0]}
                stroke="none"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Box>
  );
};

export default StarRatingChart;
